document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach((card, index) => {
    const variants = card.querySelectorAll('.product-card__variant');
    const moreVariant = card.querySelector('.product-card__variant-more');
    
    // Set fetchpriority and loading attributes for the main product image
    // First 4 product cards get high priority and eager loading, rest get low priority and lazy loading
    const mainImage = card.querySelector('.product-card__image');
    if (mainImage) {
      if (index < 4) {
        mainImage.setAttribute('fetchpriority', 'high');
        mainImage.setAttribute('loading', 'eager');
      } else {
        mainImage.setAttribute('fetchpriority', 'low');
        mainImage.setAttribute('loading', 'lazy');
      }
    }
    
    // Handle regular variant clicks
    variants.forEach(variant => {
      variant.addEventListener('click', function() {
        variants.forEach(v => v.classList.remove('active'));
        variant.classList.add('active');
        
        // Update the hidden input value with the active variant ID
        const hiddenInput = card.querySelector('input[name="id"]');
        const variantId = variant.getAttribute('data-variant-id');
        if (hiddenInput && variantId) {
          hiddenInput.value = variantId;
        }
        
        // Update image, price, and compare price
        const image = card.querySelector('.product-card__image');
        const regularPrice = card.querySelector('.product-card__price--regular');
        const discountedPrice = card.querySelector('.product-card__price--discounted');
        const regularComparePrice = card.querySelector('.product-card__compare-price--regular');
        const discountedComparePrice = card.querySelector('.product-card__compare-price--discounted');
        
        const variantImage = variant.getAttribute('data-variant-image');
        const variantImageSrcset = variant.getAttribute('data-variant-image-srcset');
        const variantPrice = variant.getAttribute('data-variant-price');
        const variantComparePrice = variant.getAttribute('data-variant-compare-price');
        const variantDiscountedPrice = variant.getAttribute('data-variant-price-discounted');
        const variantDiscountedComparePrice = variant.getAttribute('data-variant-compare-price-discounted');
        
        if (image && variantImage && variantImage !== 'null') {
          image.src = variantImage;
          if (variantImageSrcset) {
            image.srcset = variantImageSrcset;
          }
        }
        
        // Check if discount is active (only if discounted price element exists)
        const isDiscountActive = discountedPrice && discountedPrice.style.display !== 'none' && variantDiscountedPrice;
        
        if (regularPrice && variantPrice) {
          regularPrice.textContent = variantPrice;
          // Apply or remove discount styling
          if (isDiscountActive) {
            regularPrice.classList.add('discount-active');
          } else {
            regularPrice.classList.remove('discount-active');
          }
        }
        
        if (isDiscountActive && discountedPrice && variantDiscountedPrice) {
          discountedPrice.textContent = variantDiscountedPrice;
          discountedPrice.style.display = 'inline';
        } else if (discountedPrice) {
          discountedPrice.style.display = 'none';
        }
        
        if (regularComparePrice && variantComparePrice) {
          regularComparePrice.textContent = variantComparePrice;
          // Hide if compare at price is empty, 'null', or same as price
          if (!variantComparePrice.trim() || variantComparePrice === 'null' || (variantPrice && variantPrice === variantComparePrice)) {
            regularComparePrice.style.display = 'none';
          } else {
            regularComparePrice.style.display = isDiscountActive ? 'none' : '';
            // Apply or remove discount styling
            if (isDiscountActive) {
              regularComparePrice.classList.add('discount-active');
            } else {
              regularComparePrice.classList.remove('discount-active');
            }
          }
        } else if (regularComparePrice) {
          regularComparePrice.style.display = 'none';
        }
        
        if (isDiscountActive && discountedComparePrice && variantDiscountedComparePrice) {
          discountedComparePrice.textContent = variantDiscountedComparePrice;
          discountedComparePrice.style.display = 'block';
        } else if (discountedComparePrice) {
          discountedComparePrice.style.display = 'none';
        }

        // Update stock info
        const isAvailable = variant.getAttribute('data-variant-available') === 'true';
        updateStockInfo(card, isAvailable);

        // Enable/disable add-to-cart button
        const addToCartBtn = card.querySelector('.product-card__add-to-cart-btn');
        if (addToCartBtn) {
          if (isAvailable) {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('disabled');
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('disabled');
          }
        }
      });
    });

    // Handle "+N" variant click to redirect to product page
    if (moreVariant) {
      moreVariant.addEventListener('click', function() {
        const productUrl = this.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    }

    // Set first variant as active for each product card
    if (variants.length > 0) {
      variants[0].classList.add('active');
      
      // Update the hidden input with the first variant ID
      const hiddenInput = card.querySelector('input[name="id"]');
      const firstVariantId = variants[0].getAttribute('data-variant-id');
      if (hiddenInput && firstVariantId) {
        hiddenInput.value = firstVariantId;
      }
      
      // Set initial image, price, and compare price from first variant
      const image = card.querySelector('.product-card__image');
      const regularPrice = card.querySelector('.product-card__price--regular');
      const discountedPrice = card.querySelector('.product-card__price--discounted');
      const regularComparePrice = card.querySelector('.product-card__compare-price--regular');
      const discountedComparePrice = card.querySelector('.product-card__compare-price--discounted');
      
      const variantImage = variants[0].getAttribute('data-variant-image');
      const variantImageSrcset = variants[0].getAttribute('data-variant-image-srcset');
      const variantPrice = variants[0].getAttribute('data-variant-price');
      const variantComparePrice = variants[0].getAttribute('data-variant-compare-price');
      const variantDiscountedPrice = variants[0].getAttribute('data-variant-price-discounted');
      const variantDiscountedComparePrice = variants[0].getAttribute('data-variant-compare-price-discounted');
      
      if (image && variantImage && variantImage !== 'null') {
        image.src = variantImage;
        if (variantImageSrcset) {
          image.srcset = variantImageSrcset;
        }
      }
      
      // Check if discount is active (only if discounted price element exists)
      const isDiscountActive = discountedPrice && discountedPrice.style.display !== 'none' && variantDiscountedPrice;
      
      if (regularPrice && variantPrice) {
        regularPrice.textContent = variantPrice;
        // Apply or remove discount styling
        if (isDiscountActive) {
          regularPrice.classList.add('discount-active');
        } else {
          regularPrice.classList.remove('discount-active');
        }
      }
      
      if (isDiscountActive && discountedPrice && variantDiscountedPrice) {
        discountedPrice.textContent = variantDiscountedPrice;
        discountedPrice.style.display = 'inline';
      } else if (discountedPrice) {
        discountedPrice.style.display = 'none';
      }
      
      if (regularComparePrice && variantComparePrice) {
        regularComparePrice.textContent = variantComparePrice;
        // Hide if compare at price is empty, 'null', or same as price
        if (!variantComparePrice.trim() || variantComparePrice === 'null' || (variantPrice && variantPrice === variantComparePrice)) {
          regularComparePrice.style.display = 'none';
        } else {
          regularComparePrice.style.display = isDiscountActive ? 'none' : '';
          // Apply or remove discount styling
          if (isDiscountActive) {
            regularComparePrice.classList.add('discount-active');
          } else {
            regularComparePrice.classList.remove('discount-active');
          }
        }
      } else if (regularComparePrice) {
        regularComparePrice.style.display = 'none';
      }
      
      if (isDiscountActive && discountedComparePrice && variantDiscountedComparePrice) {
        discountedComparePrice.textContent = variantDiscountedComparePrice;
        discountedComparePrice.style.display = 'block';
      } else if (discountedComparePrice) {
        discountedComparePrice.style.display = 'none';
      }

      // Set initial stock info
      const isAvailable = variants[0].getAttribute('data-variant-available') === 'true';
      updateStockInfo(card, isAvailable);
      // Enable/disable add-to-cart button on load
      const addToCartBtn = card.querySelector('.product-card__add-to-cart-btn');
      if (addToCartBtn) {
        if (isAvailable) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('disabled');
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled');
        }
      }
    }
  });
});

function updateStockInfo(card, isAvailable) {
  const stockInfo = card.querySelector('.product-card__info-stock');
  const outOfStockInfo = card.querySelector('.product-card__info-out-of-stock');
  if (stockInfo && outOfStockInfo) {
    if (isAvailable) {
      stockInfo.style.display = '';
      outOfStockInfo.style.display = 'none';
    } else {
      stockInfo.style.display = 'none';
      outOfStockInfo.style.display = '';
    }
  }
}